import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { SortArrowDownSVG } from '@common_components/svg/sortArrowDown.svg';

const SortArrowDownIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <SortArrowDownSVG/>
    </div>
  );
};

export { SortArrowDownIcon };
